/**
 * Organization Service – real API only.
 */

import { normalizeServiceError } from '../utils/serviceError';
import * as realImpl from './real/organizationService.real';

const wrap = (fnName) => async (...args) => {
  try {
    return await realImpl[fnName](...args);
  } catch (error) {
    throw normalizeServiceError(error);
  }
};

export const getOrganizationById = wrap('getOrganizationById');
export const updateOrganizationV2 = wrap('updateOrganizationV2');
export const getAllOrganizations = wrap('getAllOrganizations');
export const addOrganization = wrap('addOrganization');
export const updateOrganization = wrap('updateOrganization');
export const deleteOrganization = wrap('deleteOrganization');
export const createOrganization = wrap('createOrganization');
export const createAdministrator = wrap('createAdministrator');
